export const discountToText = (discount) => {

    if (!discount) return ''
    const now = new Date(Date.now())

    // console.log('now', now)
    // console.log('discount.from', new Date(discount.from))
    // console.log('discount.to', new Date(discount.to))
    // console.log('discount', discount, now < new Date(discount.from) || now > new Date(discount.to))

    if (now < new Date(discount.from) || now > new Date(discount.to)) return ''
    // return `Sconto ${_discount.get}X${_discount.every}`
    return `Gratis ${discount.get - discount.every} ogni ${discount.every}`
  }

  export const discountToNumber = ({quantity, discount}) => {
    if (!discount) return 0
    const now = new Date(Date.now())
    if (now < discount.from || now > new Date(discount.to)) return 0
   const freeItems = Math.floor(quantity/discount.every)
    return freeItems
  }